export const colors = {
	white: '#fff',
	black: '#000',
	transparent: 'transparent',
	current: 'currentColor',
	gray: {
		50: '#F8FAFC',
		100: '#F1F5F9',
		200: '#E2E8F0',
		300: '#CBD5E1',
		400: '#94A3B8',
		500: '#64748B',
		600: '#475569',
		700: '#334155',
		800: '#1E293B',
		900: '#0F172A',
	},
	slate: {
		50: '#F8FAFC',
		100: '#F1F5F9',
		200: '#E2E8F0',
		300: '#CBD5E1',
		400: '#94A3B8',
		500: '#64748B',
		600: '#475569',
		700: '#334155',
		800: '#1E293B',
		900: '#0F172A',
	},
	indigo: {
		50: '#F3F3FF',
		100: '#EAE9FE',
		200: '#D8D6FE',
		300: '#BBB5FD',
		500: '#7B61FF',
		700: '#5428D9',
		900: '#3B1D95',
	},
	blue: {
		50: '#EFF6FF',
		100: '#DBEAFE',
		200: '#BFDBFE',
		300: '#93C5FD',
		500: '#3B82F6',
		700: '#1D4ED8',
		900: '#1E3A8A',
	},
	yellow: {
		50: '#FFFBEB',
		100: '#FFF5E0',
		200: '#FDE68A',
		300: '#FCD34D',
		500: '#F59E0B',
		700: '#B45309',
		900: '#78350F',
	},
	red: {
		50: '#FEF2F2',
		100: '#FEE2E2',
		200: '#FECACA',
		300: '#FCA5A5',
		500: '#EF4444',
		700: '#B91C1C',
		900: '#7F1D1D',
	},
	green: {
		50: '#ECFDF5',
		100: '#D1FAE5',
		200: '#A7F3D0',
		300: '#6EE7B7',
		500: '#10B981',
		600: '#059669',
		700: '#047857',
		900: '#064E3B',
	},
	chart: {
		green: '#00B9A9',
		orange: '#F25B1F',
	},
} as const;
